export default __webpack_public_path__ + "static/web20230926-2d60360a1ee3320de669da342ebeb1ac.png";